import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
export default function CloseButton(_ref) {
  var onClick = _ref.onClick,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Close' : _ref$label;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("button", {
      "aria-label": label,
      onClick: onClick,
      className: "jsx-2988351435"
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2988351435",
      children: ["button.jsx-2988351435{position:relative;border:0;background:none;cursor:pointer;width:25px;height:25px;-webkit-box-flex:0;-ms-flex:0 0 25px;-webkit-flex:0 0 25px;-ms-flex:0 0 25px;flex:0 0 25px;}", "button.jsx-2988351435:hover{opacity:0.8;}", "button.jsx-2988351435::after,button.jsx-2988351435::before{content:'';display:block;position:absolute;left:10%;top:50%;width:80%;height:1px;background:black;}", "button.jsx-2988351435::before{-webkit-transform:rotate(-45deg);-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);}", "button.jsx-2988351435::after{-webkit-transform:rotate(45deg);-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);}"]
    })]
  });
}